module.exports = __webpack_public_path__ + "img/рз_22.5b9d8d2e.png";